{
  "INBOX_MGMT": {
    "HEADER": "Hộp thư đến",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Không có hộp thư đến nào được đính kèm với tài khoản này."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Chọn kênh",
        "BODY": "Chọn nhà cung cấp bạn muốn tích hợp với Chatwoot."
      },
      "INBOX": {
        "TITLE": "Tạo Hộp thư đến",
        "BODY": "Xác thực tài khoản của bạn và tạo hộp thư đến."
      },
      "AGENT": {
        "TITLE": "Thêm đại lý",
        "BODY": "Thêm đại lý vào hộp thư đến đã tạo."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Bạn đã sẵn sàng để đi!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Tên hộp thư đến",
        "PLACEHOLDER": "Nhập tên kênh của bạn (ví dụ: WebA)",
        "ERROR": "Vui lòng nhập tên kênh hợp lệ"
      },
      "WEBSITE_NAME": {
        "LABEL": "Tên trang web",
        "PLACEHOLDER": "Nhập tên trang web của bạn (ví dụ: Acme Inc)"
      },
      "FB": {
        "HELP": "Tái bút: Bằng cách đăng nhập, chúng tôi chỉ có quyền truy cập vào các tin nhắn trên Trang của bạn. Chatwoot không bao giờ có thể truy cập tin nhắn riêng tư của bạn.",
        "CHOOSE_PAGE": "Chọn trang",
        "CHOOSE_PLACEHOLDER": "Chọn một trang từ danh sách",
        "INBOX_NAME": "Tên hộp thư đến",
        "ADD_NAME": "Thêm tên cho hộp thư đến của bạn",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Chọn một giá trị",
        "CREATE_INBOX": "Tạo Hộp thư đến"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again"
      },
      "TWITTER": {
        "HELP": "Để thêm hồ sơ Twitter của bạn làm kênh, bạn cần xác thực Hồ sơ Twitter của mình bằng cách nhấp vào 'Đăng nhập bằng Twitter",
        "ERROR_MESSAGE": "Đã xảy ra lỗi khi kết nối đến Twitter, vui lòng thử lại",
        "TWEETS": {
          "ENABLE": "Tạo cuộc trò chuyện từ các dòng Tweet được nhắn đến"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kênh trang web",
        "DESC": "Tạo kênh cho trang web của bạn và bắt đầu hỗ trợ khách hàng của bạn thông qua widget trang web của chúng tôi.",
        "LOADING_MESSAGE": "Tạo kênh hỗ trợ trang web",
        "CHANNEL_AVATAR": {
          "LABEL": "Hình đại diện kênh"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Vui lòng nhập một URL hợp lệ"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domain trang web",
          "PLACEHOLDER": "Nhập tên miền trang web của bạn (ví dụ: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Tiêu đề chào mừng",
          "PLACEHOLDER": "Chào bạn !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Dòng giới thiệu chào mừng",
          "PLACEHOLDER": "Chúng tôi làm cho việc kết nối với chúng tôi trở nên đơn giản. Hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Tin nhắn chúc mừng kênh",
          "PLACEHOLDER": "Acme Inc thường trả lời sau vài giờ."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Bật lời chào kênh",
          "HELP_TEXT": "Tự động gửi tin nhắn chào mừng khi có hội thoại mới.",
          "ENABLED": "Bật",
          "DISABLED": "Không bật"
        },
        "REPLY_TIME": {
          "TITLE": "Đặt thời gian phản hồi",
          "IN_A_FEW_MINUTES": "Trong một vài phút",
          "IN_A_FEW_HOURS": "Trong một vài giờ",
          "IN_A_DAY": "Trong một ngày",
          "HELP_TEXT": "Thời gian trả lời này sẽ được hiển thị trên tiện ích trò chuyện trực tiếp"
        },
        "WIDGET_COLOR": {
          "LABEL": "Màu tiện ích",
          "PLACEHOLDER": "Cập nhật màu tiện ích con được sử dụng trong tiện ích con"
        },
        "SUBMIT_BUTTON": "Tạo hộp thư đến",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể tạo kênh trang web, vui lòng thử lại"
        }
      },
      "TWILIO": {
        "TITLE": "Kênh Twilio SMS/WhatsApp",
        "DESC": "Tích hợp Twilio và bắt đầu hỗ trợ khách hàng của bạn qua SMS hoặc WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Tài khoản SID",
          "PLACEHOLDER": "Vui lòng nhập SID tài khoản Twilio của bạn",
          "ERROR": "Trường này là bắt buộc"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Trường này là bắt buộc"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Trường này là bắt buộc"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Dịch vụ nhắn tin SID",
          "PLACEHOLDER": "Vui lòng nhập SID của dịch vụ nhắn tin Twilio của bạn",
          "ERROR": "Trường này là bắt buộc",
          "USE_MESSAGING_SERVICE": "Sử dụng dịch vụ nhắn tin Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Loại kênh",
          "ERROR": "Vui lòng chọn loại kênh của bạn"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token xác thực",
          "PLACEHOLDER": "Vui lòng nhập Twilio Auth Token",
          "ERROR": "Trường này là bắt buộc"
        },
        "CHANNEL_NAME": {
          "LABEL": "Tên hộp thư đến",
          "PLACEHOLDER": "Vui lòng điền tên hộp thư đến",
          "ERROR": "Trường này là bắt buộc"
        },
        "PHONE_NUMBER": {
          "LABEL": "Số điện thoại",
          "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
          "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ bắt đầu bằng dấu `+` và không chứa bất kỳ dấu cách nào."
        },
        "API_CALLBACK": {
          "TITLE": "URL gọi lại",
          "SUBTITLE": "Bạn phải định cấu hình URL gọi lại tin nhắn trong Twilio với URL được đề cập ở đây."
        },
        "SUBMIT_BUTTON": "Tạo kênh Twilio",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể xác thực thông tin đăng nhập Twilio, vui lòng thử lại"
        }
      },
      "SMS": {
        "TITLE": "Kênh SMS",
        "DESC": "Bắt đầu hỗ trợ khách hàng thông qua SMS.",
        "PROVIDERS": {
          "LABEL": "Nhà cung cấp API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID Tài khoản",
            "PLACEHOLDER": "Vui lòng nhập ID Tài khoản Bandwidth",
            "ERROR": "Trường này là bắt buộc"
          },
          "API_KEY": {
            "LABEL": "Khoá API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Trường này là bắt buộc"
          },
          "API_SECRET": {
            "LABEL": "Bí mật API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Trường này là bắt buộc"
          },
          "APPLICATION_ID": {
            "LABEL": "ID ứng dụng",
            "PLACEHOLDER": "Vui lòng nhập ID Ứng dụng Bandwidth",
            "ERROR": "Trường này là bắt buộc"
          },
          "INBOX_NAME": {
            "LABEL": "Tên hộp thư đến",
            "PLACEHOLDER": "Vui lòng điền tên kênh",
            "ERROR": "Trường này là bắt buộc"
          },
          "PHONE_NUMBER": {
            "LABEL": "Số Điện Thoại",
            "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
            "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ bắt đầu bằng dấu `+` và không chứa bất kỳ dấu cách nào."
          },
          "SUBMIT_BUTTON": "Tạo kênh Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Chúng tôi không thể xác thực \bchứng chỉ Bandwidth, vui lòng thử lại"
          },
          "API_CALLBACK": {
            "TITLE": "URL gọi lại",
            "SUBTITLE": "Bạn phải cấu hình tin nhắn URL gọi lại trong Bandwith với URL đã được đề cập ở đây."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "Kênh WhatsApp",
        "DESC": "Bắt đầu hỗ trợ khách hàng thông qua WhatsApp.",
        "PROVIDERS": {
          "LABEL": "Nhà cung cấp API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "Đám mây WhatsApp",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Tên hộp thư đến",
          "PLACEHOLDER": "Vui lòng điền tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "PHONE_NUMBER": {
          "LABEL": "Số Điện Thoại",
          "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
          "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ bắt đầu bằng dấu `+` và không chứa bất kỳ dấu cách nào."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID số điện thoại",
          "PLACEHOLDER": "Vui lòng nhập ID số điện thoại lấy được từ trang tổng quan nhà phát triển Facebook.",
          "ERROR": "Vui lòng điền giá trị hợp lệ."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "ID tài khoản doanh nghiệp",
          "PLACEHOLDER": "Vui lòng nhập ID tài khoản doanh nghiệp có được từ trang tổng quan dành cho nhà phát triển Facebook.",
          "ERROR": "Vui lòng điền giá trị hợp lệ."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Token xác thực Webhook",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Vui lòng điền giá trị hợp lệ."
        },
        "API_KEY": {
          "LABEL": "Khoá API",
          "SUBTITLE": "Cấu hình Khoá API WhatsApp.",
          "PLACEHOLDER": "Khoá API",
          "ERROR": "Vui lòng điền giá trị hợp lệ."
        },
        "API_CALLBACK": {
          "TITLE": "URL gọi lại",
          "SUBTITLE": "Bạn phải định cấu hình URL webhook và mã xác minh trong cổng Nhà phát triển của Facebook với các giá trị được hiển thị bên dưới.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Mã xác minh Webhook"
        },
        "SUBMIT_BUTTON": "Tạo kênh WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh WhatsApp"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Số điện thoại",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Tài khoản SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Token xác thực",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Kênh API",
        "DESC": "Tích hợp với kênh API và bắt đầu hỗ trợ khách hàng của bạn.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Tạo kênh API",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh api"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Kênh Email",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Tên kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Tạo kênh Email",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh email"
        },
        "FINISH_MESSAGE": "Bắt đầu chuyển tiếp email của bạn tới địa chỉ email sau.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Click vào đây",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "Kênh LINE",
        "DESC": "Tích hợp với kênh LINE và bắt đầu hỗ trợ khách hàng của bạn.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID Kênh LINE",
          "PLACEHOLDER": "ID Kênh LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Bí mật Kênh LINE",
          "PLACEHOLDER": "Bí mật Kênh LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token Kênh LINE",
          "PLACEHOLDER": "Token Kênh LINE"
        },
        "SUBMIT_BUTTON": "Tạo Kênh LINE",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL gọi lại",
          "SUBTITLE": "Bạn phải cấu hình webhook URL trong ứng dụng LINE với URL được nhắc đến ở đây."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Kênh Telegram",
        "DESC": "Tích hợp với kênh Telegram và bắt đầu hỗ trợ khách hàng của bạn.",
        "BOT_TOKEN": {
          "LABEL": "Token Bot",
          "SUBTITLE": "Cấu hình token bot mà bạn đã nhận được từ Telegram BotFather.",
          "PLACEHOLDER": "Token Bot"
        },
        "SUBMIT_BUTTON": "Tạo Kênh Telegram",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh \btelegram"
        }
      },
      "AUTH": {
        "TITLE": "Chọn kênh",
        "DESC": "Chatwoot hỗ trợ các tiện ích trò chuyện trực tiếp, Facebook Messenger, hồ sơ Twitter, WhatsApp, Email, v. v., dưới dạng các kênh. Nếu bạn muốn xây dựng một kênh tùy chỉnh, bạn có thể tạo kênh này bằng cách sử dụng kênh API. Để bắt đầu, hãy chọn một trong các kênh bên dưới.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "Email",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Nhà Cung Cấp",
        "DESC": "Tại đây bạn có thể thêm các tác nhân để quản lý hộp thư đến mới tạo của mình. Chỉ những đại lý được chọn này mới có quyền truy cập vào hộp thư đến của bạn. Các nhân viên không thuộc hộp thư đến này sẽ không thể xem hoặc trả lời thư trong hộp thư đến này khi họ đăng nhập. <br> <b>PS:</b> Với tư cách là quản trị viên, nếu bạn cần quyền truy cập vào tất cả các hộp thư đến, bạn nên thêm mình làm đại lý cho tất cả các hộp thư đến mà bạn tạo.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Chọn đại lý cho hộp thư đến"
      },
      "DETAILS": {
        "TITLE": "Chi tiết Hộp thư đến",
        "DESC": "Từ menu thả xuống bên dưới, chọn Trang Facebook bạn muốn kết nối với Chatwoot. Bạn cũng có thể đặt tên tùy chỉnh cho hộp thư đến của mình để nhận dạng tốt hơn."
      },
      "FINISH": {
        "TITLE": "Đúng rồi!",
        "DESC": "Bạn đã tích hợp thành công Trang Facebook của mình với Chatwoot. Lần tới khi khách hàng nhắn tin cho Trang của bạn, cuộc trò chuyện sẽ tự động xuất hiện trong hộp thư đến của bạn.<br>Chúng tôi cũng đang cung cấp cho bạn tập lệnh widget mà bạn có thể dễ dàng thêm vào trang web của mình. Khi điều này xuất hiện trên trang web của bạn, khách hàng có thể nhắn tin cho bạn ngay từ trang web của bạn mà không cần sự trợ giúp của bất kỳ công cụ bên ngoài nào và cuộc trò chuyện sẽ xuất hiện ngay tại đây, trên Chatwoot.<br>Cool, huh? Well :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Xác thực bạn bằng Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Đã xảy ra sự cố, Vui lòng làm mới trang...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Tạo Hộp thư đến của bạn...",
      "TITLE": "Cấu hình chi tiết hộp thư đến",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Thêm các nhà cung cấp",
      "ADD_AGENTS": "Thêm các nhà cung cấp vào hộp thư đến của bạn..."
    },
    "FINISH": {
      "TITLE": "Hộp thư đến của bạn đã sẵn sàng!",
      "MESSAGE": "Giờ đây, bạn có thể tương tác với khách hàng thông qua Kênh mới của mình. Chúc vui vẻ ủng hộ",
      "BUTTON_TEXT": "Đưa cho tôi",
      "MORE_SETTINGS": "Nhiều tuỳ chọn hơn",
      "WEBSITE_SUCCESS": "Bạn đã hoàn thành việc tạo kênh trang web thành công. Sao chép mã được hiển thị bên dưới và dán vào trang web của bạn. Lần tới khi khách hàng sử dụng cuộc trò chuyện trực tiếp, cuộc trò chuyện sẽ tự động xuất hiện trong hộp thư đến của bạn.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Ủy quyền lại",
    "VIEW": "Xem",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Đã cập nhật cài đặt hộp thư đến thành công",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Đã cập nhật thành công bài tập tự động",
        "ERROR_MESSAGE": "Chúng tôi không thể cập nhật cài đặt hộp thư. Vui lòng thử lại sau."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "từ",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Bật"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Xoá",
      "AVATAR_DELETE_BUTTON_TEXT": "Xoá hình đại diện",
      "CONFIRM": {
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có muốn xoá? ",
        "PLACE_HOLDER": "Vui lòng điền {inboxName} để xác nhận",
        "YES": "Có, Xoá ",
        "NO": "Không, Giữ "
      },
      "API": {
        "SUCCESS_MESSAGE": "Hộp thư đến đã được xóa thành công",
        "ERROR_MESSAGE": "Không thể xóa hộp thư đến. Vui lòng thử lại sau.",
        "AVATAR_SUCCESS_MESSAGE": "Hình đại diện của hộp thư đến đã được xoá thành công",
        "AVATAR_ERROR_MESSAGE": "Không thể xoá hình đại diện của hộp thư đến. Vui lòng thử lại sau."
      }
    },
    "TABS": {
      "SETTINGS": "Cài đặt",
      "COLLABORATORS": "Cộng tác viên",
      "CONFIGURATION": "Cấu hình",
      "CAMPAIGN": "Chiến dịch",
      "PRE_CHAT_FORM": "Biểu mẫu trước khi trò chuyện",
      "BUSINESS_HOURS": "Giờ làm việc",
      "WIDGET_BUILDER": "Trình tạo widget",
      "BOT_CONFIGURATION": "Cấu hình Bot",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Trực tuyến"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Cài đặt",
    "FEATURES": {
      "LABEL": "Các tính năng",
      "DISPLAY_FILE_PICKER": "Hiển thị bộ chọn tệp trên tiện ích con",
      "DISPLAY_EMOJI_PICKER": "Hiển thị bộ chọn biểu tượng cảm xúc trên tiện ích con",
      "ALLOW_END_CONVERSATION": "Cho phép người dùng kết thúc cuộc trò chuyện từ công cụ chat",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Tập lệnh Messenger",
      "MESSENGER_SUB_HEAD": "Đặt nút này bên trong thẻ body của bạn",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Nhà cung cấp",
      "INBOX_AGENTS_SUB_TEXT": "Thêm hoặc xóa tác nhân khỏi hộp thư đến này",
      "AGENT_ASSIGNMENT": "Phân công cuộc trò chuyện",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Cập nhật phân công cuộc trò chuyện",
      "UPDATE": "Cập nhật",
      "ENABLE_EMAIL_COLLECT_BOX": "Bật hộp thu thập email",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Bật hoặc tắt hộp thu thập email trên cuộc trò chuyện mới",
      "AUTO_ASSIGNMENT": "Bật tự động chuyển nhượng",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Bật tiếp tục cuộc trò chuyện qua email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Cuộc trò chuyện sẽ tiếp tục qua email nếu có địa chỉ email liên lạc.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Cài đặt Hộp thư đến",
      "INBOX_UPDATE_SUB_TEXT": "Cập nhật cài đặt hộp thư đến của bạn",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Bật hoặc tắt tính năng tự động gán các cuộc hội thoại mới cho các tác nhân được thêm vào hộp thư đến này.",
      "HMAC_VERIFICATION": "Xác thực danh tính người dùng",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Bắt buộc Xác thực danh tính người dùng",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "INBOX_IDENTIFIER": "Định danh hộp thư đến",
      "INBOX_IDENTIFIER_SUB_TEXT": "Dùng token định danh hộp thư đến hiện ở đây để xác thực các ứng dụng khách API của bạn.",
      "FORWARD_EMAIL_TITLE": "Chuyển tiếp đến Email",
      "FORWARD_EMAIL_SUB_TEXT": "Bắt đầu chuyển tiếp email của bạn tới địa chỉ email sau.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Cho phép nhắn tin sau khi cuộc trò chuyện được giải quyết",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Cho phép người dùng cuối nhắn tin sau khi cuộc trò chuyện được giải quyết.",
      "WHATSAPP_SECTION_SUBHEADER": "Khóa API này được sử dụng để tích hợp với các API WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "Khoá API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Update API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Enter the new API Key here",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Cập nhật",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Kết nối",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Mã xác minh Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "This token is used to verify the authenticity of the webhook endpoint.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings"
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "NONE": "Không có",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Giới hạn tự động phân công tối đa",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Xin nhập vào một số lớn hơn 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Giới hạn số cuộc trò chuyện tối đa từ hộp thư này mà có thể được tự động phân công cho một hỗ trợ viên"
    },
    "ASSIGNMENT": {
      "TITLE": "Phân công cuộc trò chuyện",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Có hiệu lực",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Huỷ",
      "CONFIRM_DELETE": "Xoá",
      "DELETE_SUCCESS": "Đã xóa chính sách phân công thành công",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ủy quyền lại",
      "SUBTITLE": "Kết nối Facebook của bạn đã hết hạn, vui lòng kết nối lại trang Facebook của bạn để tiếp tục dịch vụ",
      "MESSAGE_SUCCESS": "Kết nối lại thành công",
      "MESSAGE_ERROR": "Đã có lỗi, vui lòng thử lại"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Biểu mẫu trước khi trò chuyện cho phép bạn nắm bắt thông tin người dùng trước khi họ bắt đầu cuộc trò chuyện với bạn.",
      "SET_FIELDS": "Những ô cần điền vào trước cuộc trò chuyện",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Ô cần điền",
        "LABEL": "Nhãn",
        "PLACE_HOLDER": "Cụm từ hiện nền trong ô",
        "KEY": "Khoá",
        "TYPE": "Kiểu",
        "REQUIRED": "Bắt buộc"
      },
      "ENABLE": {
        "LABEL": "Bật biểu mẫu trước khi trò chuyện",
        "OPTIONS": {
          "ENABLED": "Có",
          "DISABLED": "Không"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Tin nhắn trước khi trò chuyện",
        "PLACEHOLDER": "Tin nhắn này sẽ hiện cho những người dùng cùng với biểu mẫu"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Khách truy cập nên cung cấp tên và địa chỉ email của họ trước khi bắt đầu trò chuyện"
      }
    },
    "CSAT": {
      "TITLE": "Bật chỉ số đo lường sự hài lòng khách hàng",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Tin nhắn",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Ngôn ngữ",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Trở về"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "chứa",
          "DOES_NOT_CONTAINS": "không bao gồm"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Đặt tính khả dụng của bạn",
      "SUBTITLE": "Đặt tính khả dụng của bạn trên tiện ích trò chuyện trực tiếp",
      "WEEKLY_TITLE": "Đặt giờ hàng tuần của bạn",
      "TIMEZONE_LABEL": "Chọn múi giờ",
      "UPDATE": "Cập nhật tuỳ chỉnh giờ làm việc",
      "TOGGLE_AVAILABILITY": "Kích hoạt tính khả dụng của doanh nghiệp cho hộp thư đến này",
      "UNAVAILABLE_MESSAGE_LABEL": "Thông báo không có sẵn cho khách truy cập",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "Ngày",
        "AVAILABILITY": "Khả dụng",
        "HOURS": "Hours",
        "ENABLE": "Kích hoạt tính khả dụng cho hôm nay",
        "UNAVAILABLE": "Không có sẵn",
        "VALIDATION_ERROR": "Giờ bắt đầu nên trước giờ đóng cửa.",
        "CHOOSE": "Chọn"
      },
      "ALL_DAY": "Cả ngày"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Đặt chi tiết IMAP",
      "NOTE_TEXT": "Để bật chế độ SMTP, xin hãy cấu hình IMAP.",
      "UPDATE": "Cập nhật chi tiết IMAP",
      "TOGGLE_AVAILABILITY": "Kích hoạt cấu hình IMAP cho hộp thư đến này",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Tuỳ chỉnh IMAP được cập nhật thành công",
        "ERROR_MESSAGE": "Không thể cập nhật tuỳ chỉnh IMAP"
      },
      "ADDRESS": {
        "LABEL": "Địa chỉ",
        "PLACE_HOLDER": "Địa chỉ (Ví dụ: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Đăng nhập",
        "PLACE_HOLDER": "Đăng nhập"
      },
      "PASSWORD": {
        "LABEL": "Mật khẩu",
        "PLACE_HOLDER": "Mật khẩu"
      },
      "ENABLE_SSL": "Kích hoạt SSL",
      "AUTH_MECHANISM": "Xác minh"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "STMP",
      "SUBTITLE": "Đặt chi tiết SMTP",
      "UPDATE": "Cập nhật tuỳ chỉnh SMTP",
      "TOGGLE_AVAILABILITY": "Kích hoạt cấu hình SMTP cho hộp thư đến này",
      "TOGGLE_HELP": "Kích hoạt SMTP sẽ giúp cho người dùng gửi email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Tuỳ chỉnh SMTP được cập nhật thành công",
        "ERROR_MESSAGE": "Không thể cập nhật tuỳ chỉnh SMTP"
      },
      "ADDRESS": {
        "LABEL": "Địa chỉ",
        "PLACE_HOLDER": "Địa chỉ (Ví dụ: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Đăng nhập",
        "PLACE_HOLDER": "Đăng nhập"
      },
      "PASSWORD": {
        "LABEL": "Mật khẩu",
        "PLACE_HOLDER": "Mật khẩu"
      },
      "DOMAIN": {
        "LABEL": "Miền",
        "PLACE_HOLDER": "Miền"
      },
      "ENCRYPTION": "Mã hoá",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Mở Chế độ xác minh SSL",
      "AUTH_MECHANISM": "Xác minh"
    },
    "NOTE": "Ghi chú: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Hình đại diện trang web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Hình đại diện đã được xóa thành công",
              "ERROR_MESSAGE": "Đã có lỗi, vui lòng thử lại"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Tên trang web",
          "PLACE_HOLDER": "Nhập tên trang web của bạn (ví dụ: Acme Inc)",
          "ERROR": "Vui lòng nhập tên trang web hợp lệ"
        },
        "WELCOME_HEADING": {
          "LABEL": "Tiêu đề chào mừng",
          "PLACE_HOLDER": "Chào bạn!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Dòng giới thiệu chào mừng",
          "PLACE_HOLDER": "Chúng tôi làm cho việc kết nối với chúng tôi trở nên đơn giản. Hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn."
        },
        "REPLY_TIME": {
          "LABEL": "Thời gian trả lời",
          "IN_A_FEW_MINUTES": "Trong một vài phút",
          "IN_A_FEW_HOURS": "Trong một vài giờ",
          "IN_A_DAY": "Trong một ngày"
        },
        "WIDGET_COLOR_LABEL": "Màu tiện ích",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Kiểu:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Trò chuyện với chúng tôi",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Trò chuyện với chúng tôi"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Cập nhật cài đặt widget",
          "API": {
            "SUCCESS_MESSAGE": "Đã cập nhật cài đặt widget thành công",
            "ERROR_MESSAGE": "Không thể cập nhật cài đặt widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Xem trước",
          "SCRIPT": "Kịch bản"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Trái",
          "RIGHT": "Phải"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Chuẩn",
          "EXPANDED_BUBBLE": "Mở rộng bong bóng"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Mặc định",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Thường trả lời sau vài phút",
        "IN_A_FEW_HOURS": "Thường trả lời sau vài giờ",
        "IN_A_DAY": "Thường trả lời trong một ngày"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Bắt đầu một cuộc trò chuyện",
        "CHAT_INPUT_PLACEHOLDER": "Gõ tin nhắn của bạn"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Chúng tôi đang trực tuyến",
          "OFFLINE": "Hiện tại chúng tôi đang bận chút"
        },
        "USER_MESSAGE": "Xin chào",
        "AGENT_MESSAGE": "Xin chào"
      },
      "BRANDING_TEXT": "CC bởi Chatwoot",
      "SCRIPT_SETTINGS": "\nwindow.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Other Providers",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Kênh API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
